import httpService from 'services/httpService.js';
import { base_url } from "Constants";

// Video player functions
//#region Video player functions
// var wName;
var pausedAt, playedFrom;
window.name = "";
// var videoInterval = null;

var videoIntervalDateChange = null;
var videoClicked = false; // #TODO what does it exactly mean by video "clicked"? does it mean "played at least once"? When it is set to true / false? Review all assignments in this js file.
var secondsCount = 0;
var oldVideoDate = null; // #TODO what does it mean? When it is set to true / false? Review all assignments in this js file.
var clickCountSaved = false;

var timeStarted = -1;
var timePlayed = 0;
var timeframes = [];
var new_timeframes = [];
var timesframestopass = [];
var videoPaused = true;

export function startVideoTimer(video_id = null) { // example value is video_id = 459
    var media = document.querySelector('#video-player_html5_api > video');
    // log.log({ videoStats: media });
    if (media) {
        // log.log("videoStats in medi", window.name);
        if (window.name === "") { //[-] #TODO when it will be ""? why to set it to (video_id + "-0")?
            //why set videoClicked = false? Because by default video is not playing?
            window.name = video_id + "-0"; //[-] #TODO what populates window.name? The example value is "461-1"; Why its different from video_id = 459?
            videoClicked = false;
            // log.log("videoStats in medi window.name===''", window.name);
        }
        else {
            var splitarr = window.name.split('-');
            if (splitarr[1] === "1") {  // #TODO when this will get executed? might get executed refreshed
                SaveVideoStats(video_id); // #TODO why save if(splitarr[1] === "1")?
            }
            else {
                window.name = video_id + "-0"; // #TODO why set in else() ?
                videoClicked = false; // #TODO why videoClicked is set to false in else()? Also, why its not set to anything in immediately previous if()?
            }
        }

        media.addEventListener("play", function () {
            videoPaused = false;
            timeStarted = new Date().getTime() / 1000;
            playedFrom = Math.round(media.currentTime);
            window.name = (window.name).slice(0, -1) + '1'; // #TODO why do this? Wont it leave window.name = "459-1" unchanged? "-1" might be indicating PLAY state
            // log.log("videoStats in media play listener", window.name, videoClicked);

            if (!videoClicked) { // #TODO Check: playing first time
                videoClicked = true;
                oldVideoDate = new Date(); // #TODO does it simply mean from

                // While playing a video, to keep track of date change, following interval is used.
                videoIntervalDateChange = window.setInterval(onVideoTimerForDateChange, 1000);
            }
        });

        media.addEventListener("pause", function (_event) {
            videoPaused = true;
            // log.log("videoStats in media play listener", window.name, { videoPaused, timeStarted });
            if (timeStarted > 0) {
                var playedFor = new Date().getTime() / 1000 - timeStarted;
                timeStarted = -1;
                timePlayed += Math.round(playedFor);
                // log.log("videoStats in media play listener timeStarted > 0 ", window.name, { playedFor, timeStarted });
                calculate_timeframes(Math.round(playedFor));
            }
        });
    }

    function onVideoTimerForDateChange() {
        secondsCount = secondsCount + 1;
        var temp_oldVideoDate = oldVideoDate.getFullYear() + "-" + // TODO why we are dealing with only dates and not time?
            (oldVideoDate.getMonth() + 1) + "-" +
            oldVideoDate.getDate();

        var newVideoDate = new Date();
        var temp_newVideoDate = newVideoDate.getFullYear() + "-" +
            (newVideoDate.getMonth() + 1) + "-" +
            newVideoDate.getDate();
        // log.log("videoStats onVideoTimerForDateChange", { secondsCount, videoPaused, temp_oldVideoDate, newVideoDate, temp_newVideoDate })
        if (temp_oldVideoDate !== temp_newVideoDate) {
            SaveVideoStats_AfterDateChange();
            secondsCount = 0;
        }
        else if (secondsCount === 300 && videoPaused === false) {
            SaveVideoStats_After300Seconds();
            secondsCount = 0;
        }
        else {
            oldVideoDate = new Date();
        }
    }
}

function calculate_timeframes(playedFor = 0) {
    var i = 0;
    var fromPositionFixed = false;
    var atPositionFixed = false;
    pausedAt = playedFrom + playedFor;
    // log.log("videoStats in media play listener timeStarted > 0 ", window.name, { fromPositionFixed, atPositionFixed, pausedAt, timeframes });
    if (timeframes.length > 0) {
        new_timeframes = timeframes;
        while (i < timeframes.length) {
            if (playedFrom <= timeframes[i]) {
                if (i % 2 === 0) {
                    if (pausedAt < timeframes[i]) {
                        new_timeframes.splice(i, 0, playedFrom);
                        new_timeframes.splice(i + 1, 0, pausedAt);
                        fromPositionFixed = true;
                        atPositionFixed = true;
                        break;
                    }
                    else if (pausedAt === timeframes[i]) {
                        new_timeframes[i] = playedFrom;
                        fromPositionFixed = true;
                        atPositionFixed = true;
                        break;
                    }
                    else {
                        if (pausedAt <= timeframes[i + 1]) {
                            new_timeframes[i] = playedFrom;
                            fromPositionFixed = true;
                            atPositionFixed = true;
                            break;
                        }
                        else {
                            new_timeframes[i] = playedFrom;
                            new_timeframes[i + 1] = -1;
                            fromPositionFixed = true;
                            i = i + 2;
                            break;
                        }
                    }
                }
                else {
                    if (pausedAt <= timeframes[i]) {
                        fromPositionFixed = true;
                        atPositionFixed = true;
                        break;
                    }
                    else {
                        if ((i + 1) < timeframes.length) {
                            if (pausedAt < timeframes[i + 1]) {
                                new_timeframes[i] = pausedAt;
                                fromPositionFixed = true;
                                atPositionFixed = true;
                                break;
                            }
                            else if (pausedAt === timeframes[i + 1]) {
                                new_timeframes[i] = -1;
                                new_timeframes[i + 1] = -1;
                                fromPositionFixed = true;
                                atPositionFixed = true;
                                break;
                            }
                            else {
                                new_timeframes[i] = -1;
                                new_timeframes[i + 1] = -1;
                                i = i + 2;
                                break;
                            }
                        }
                        else {
                            new_timeframes[i] = pausedAt;
                            fromPositionFixed = true;
                            atPositionFixed = true;
                            break;
                        }
                    }
                }
            }
            i = i + 1;
        }

        if (atPositionFixed === false) {
            while (i < timeframes.length) {
                if (i % 2 === 0) {
                    if (pausedAt < timeframes[i]) {
                        new_timeframes[i - 1] = pausedAt;
                        fromPositionFixed = true;
                        atPositionFixed = true;
                        break;
                    }
                    else if (pausedAt === timeframes[i]) {
                        new_timeframes[i] = -1;
                        fromPositionFixed = true;
                        atPositionFixed = true;
                        break;
                    }
                    else {
                        if (pausedAt <= timeframes[i + 1]) {
                            new_timeframes[i] = -1;
                            fromPositionFixed = true;
                            atPositionFixed = true;
                            break;
                        }
                        else {
                            new_timeframes[i] = -1;
                            new_timeframes[i + 1] = -1;
                            i = i + 2;
                        }
                    }
                }
                else {
                    if (pausedAt <= timeframes[i]) {
                        fromPositionFixed = true;
                        atPositionFixed = true;
                        break;
                    }
                    else {
                        if ((i + 1) < timeframes.length) {
                            if (pausedAt < timeframes[i + 1]) {
                                new_timeframes[i] = pausedAt;
                                fromPositionFixed = true;
                                atPositionFixed = true;
                                break;
                            }
                            else if (pausedAt === timeframes[i + 1]) {
                                new_timeframes[i] = -1;
                                new_timeframes[i + 1] = -1;
                                fromPositionFixed = true;
                                atPositionFixed = true;
                                break;
                            }
                            else {
                                i = i + 2;
                            }
                        }
                    }
                }
            }
        }

        if (fromPositionFixed === false) {
            new_timeframes.push(playedFrom);
            new_timeframes.push(pausedAt);
        }
        else if (atPositionFixed === false) {
            new_timeframes.push(pausedAt);
        }
    }
    else {
        timeframes.push(playedFrom);
        timeframes.push(pausedAt);
        new_timeframes = timeframes;
    }

    timesframestopass = [];
    for (let k = 0; k < new_timeframes.length; k++) {
        if (new_timeframes[k] !== -1) {
            timesframestopass.push(new_timeframes[k]);
        }
    }

    timeframes = timesframestopass;
    // log.log("videoStats in media play listener timeStarted > 0 ", window.name, { fromPositionFixed, atPositionFixed, pausedAt, timeframes, timesframestopass });
}

export function stopVideoTimerForDateChange() {
    window.clearInterval(videoIntervalDateChange);
    videoIntervalDateChange = null;
    secondsCount = 0;
    clickCountSaved = false;
    videoClicked = false;
}

export async function SaveVideoStats(video_id = null, windowName = "", sendBeacon) {
    var clickCount = clickCountSaved ? 0 : 1;
    var splitarr = windowName === "" ? window.name.split('-') : windowName.split('-');
    // log.log("videoStats saveVideoStats", { clickCount, splitarr });
    if (splitarr[1] === "1") {
      if (timeStarted > 0) {
        var playedFor = new Date().getTime() / 1000 - timeStarted;
        timeStarted = -1;
        timePlayed += Math.round(playedFor);
        calculate_timeframes(Math.round(playedFor));
      }
      var url = '/statistics/videostatistics/?format=json';
      let data = {
        'video_id': splitarr[0],
        'watchedTime': timePlayed,
        'eventName': "",
        'oldDate': oldVideoDate.toUTCString(),
        'clickCount': clickCount,
        'timeframes': timesframestopass.toString()
      };
      if (sendBeacon) {
        // const headers = {
        //     type: 'application/json',
        //     origin: base_url
        // };
        // const blob = new Blob([JSON.stringify(data)], headers);
        data['token'] = localStorage.token && localStorage.token.split("Token ")[1];
        navigator.sendBeacon(base_url + url, JSON.stringify(data));
        // log.log("Executed sendBeacon", data);
      } else {
        try {
          const response = await httpService.post(url, data);
          if (video_id) {
            window.name = video_id.toString() + "-0";
          } else {
            window.name = "";
          }
          timePlayed = 0;
          timeframes = [];
          new_timeframes = [];
          timesframestopass = [];
          stopVideoTimerForDateChange();
        } catch (response) {
          // log.log(response);
          stopVideoTimerForDateChange();
        }
      }
    }
  }

  async function SaveVideoStats_After300Seconds() {
    var playedFor = 0;
    var clickCount = clickCountSaved ? 0 : 1;
    var splitarr = window.name.split('-');
    // log.log("videoStats SaveVideoStats_After300Seconds", { playedFor, clickCount, splitarr, timeStarted })
    if (splitarr[1] === "1") {
      if (timeStarted > 0) {
        playedFor = Math.round(new Date().getTime() / 1000 - timeStarted);
        timeStarted = new Date().getTime() / 1000;
        timePlayed += Math.round(playedFor);
        calculate_timeframes(playedFor);
      }
      var url = '/statistics/videostatistics/?format=json';
      let data = {
        'video_id': splitarr[0],
        'watchedTime': timePlayed,
        'eventName': "",
        'oldDate': oldVideoDate.toUTCString(),
        'clickCount': clickCount,
        'timeframes': timesframestopass.toString()
      };
      try {
        const response = await httpService.post(url, data);
        clickCountSaved = true;
        oldVideoDate = new Date();
        playedFrom = playedFrom + playedFor;
        timePlayed = 0;
      } catch (response) {
        oldVideoDate = new Date();
        // log.log(response);
      }
    }
}

async function SaveVideoStats_AfterDateChange() {
    var playedFor = 0;
    var clickCount = clickCountSaved ? 0 : 1;
    var old_videoDate = oldVideoDate;
    var splitarr = window.name.split('-');
    oldVideoDate = new Date();
    // log.log("videoStats SaveVideoStats_AfterDateChange", { clickCount, old_videoDate, splitarr })
    if (splitarr[1] === "1") {
      if (timeStarted > 0) {
        playedFor = Math.round(new Date().getTime() / 1000 - timeStarted);
        timeStarted = new Date().getTime() / 1000;
        timePlayed += Math.round(playedFor);
        calculate_timeframes(playedFor);
      }
      var url = '/statistics/videostatistics/?format=json';
      let data = {
        'video_id': splitarr[0],
        'watchedTime': timePlayed,
        'oldDate': old_videoDate.toUTCString(),
        'eventName': "afterDateChange",
        'clickCount': clickCount,
        'timeframes': timesframestopass.toString()
      };
      try {
        const response = await httpService.post(url, data);
        clickCountSaved = true;
        playedFrom = playedFrom + playedFor;
        timePlayed = 0;
        timeframes = [];
        new_timeframes = [];
        timesframestopass = [];
      } catch (response) {
        // log.log(response);
      }
    }
}

//#endregion